import React, { useCallback, type PropsWithChildren } from 'react';

import { SpotlightTarget } from '@atlaskit/onboarding';
import { EngagementSpotlight } from '@atlassiansox/engagekit-ts';

export const useSpotlightWrapper = (id: string) => {
	return useCallback(
		({ children }: PropsWithChildren<{}>) => (
			<div>
				<SpotlightTarget name={id}>{children}</SpotlightTarget>
				<EngagementSpotlight engagementId={id} />
			</div>
		),
		[id],
	);
};
